module.exports = __webpack_public_path__ + "img/ad-kp.d5b3645a.png";